module.exports = __webpack_public_path__ + "static/media/bg_top_up_option_2.16f87a6d.png";